import { createAction } from '@reduxjs/toolkit'

export const setSidebarIsCollapsed = createAction<boolean>('user/setSidebarIsCollapsed')
export const setExpandedSidebarSection = createAction<string>('user/setExpandedSidebarSection')
